import React, { useState, useEffect } from "react";
import "../CSS/SemuaDataPasienTK.css";
import { FaSearch, FaFileAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

function DataPasienTenagaKesehatan() {
  const navigate = useNavigate();

  const [dataPasien, setDataPasien] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterStatus, setFilterStatus] = useState("");
  const [filterWilayah, setFilterWilayah] = useState("");
  const [filterNakes, setFilterNakes] = useState("");

  // Ambil data dari Flask backend
  useEffect(() => {
    fetch("http://127.0.0.1:5000/api/json") // Panggil API dari backend Flask
      .then((res) => res.json())  // Convert respons ke JSON
      .then((data) => {
        // Pdata.dataPasien
        setDataPasien(Array.isArray(data) ? data : data.dataPasien || []);
      })
      .catch((err) => console.error("Error fetching pasien:", err));
  }, []);

  // Filter data pasien
  const filteredPasien = dataPasien.filter((pasien) => {
    const nama = pasien.nama_pasien ?? "";
    const status = pasien.statusTerapi ?? "";
    const alamat = pasien.alamat ?? "";
    const nakes = pasien.nakes ?? "";

    return (
      nama.toLowerCase().includes(searchTerm.toLowerCase()) &&
      (filterStatus ? status === filterStatus : true) &&
      (filterWilayah ? alamat === filterWilayah : true) &&
      (filterNakes ? nakes === filterNakes : true)
    );
  });

  const handleDetailClick = (id) => {
    navigate(`/HalamanDetailPasienTK/${id}`);
  };

  return (
    <div className="data-pasien-page">
      <div className="content-pasien">
        {/* Filter Section */}
        <div className="filter-section">
          <div className="search-box">
            <FaSearch className="search-icon" />
            <input
              type="text"
              placeholder="Search Nama Pasien"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>

          <select value={filterStatus} onChange={(e) => setFilterStatus(e.target.value)}>
            <option value="">Status Pasien</option>
            <option value="Aktif">Aktif</option>
            <option value="Selesai">Selesai</option>
          </select>

          <select value={filterWilayah} onChange={(e) => setFilterWilayah(e.target.value)}>
            <option value="">Wilayah</option>
            <option value="Surakarta">Surakarta</option>
            <option value="Solo">Solo</option>
            <option value="Sukoharjo">Sukoharjo</option>
            <option value="Karanganyar">Karanganyar</option>
            <option value="Boyolali">Boyolali</option>
          </select>

          <select value={filterNakes} onChange={(e) => setFilterNakes(e.target.value)}>
            <option value="">Nakes</option>
            <option value="Dr. Megumi">Dr. Megumi</option>
          </select>
        </div>

        {/* Table */}
        <div className="table-container">
          <table className="table-pasien">
            <thead>
              <tr>
                <th>No</th>
                <th>Nama Pasien</th>
                <th>Umur</th>
                <th>Nakes</th>
                <th>Alamat</th>
                <th>Status Terapi</th>
                <th>Resiko Putus Obat</th>
                <th>Progress Terapi</th>
                <th>Aksi</th>
              </tr>
            </thead>
            <tbody>
              {filteredPasien.length > 0 ? (
                filteredPasien.map((pasien, index) => (
                  <tr key={pasien.id_pasien}>
                    <td>{index + 1}</td>
                    <td>{pasien.nama_pasien}</td>
                    <td>{pasien.umur_pasien}</td>
                    <td>{pasien.nakes}</td>
                    <td>{pasien.alamat}</td>
                    <td>{pasien.statusTerapi}</td>
                    <td>{pasien.resikoPutusObat}</td>
                    <td>{pasien.progressTerapi}</td>
                    <td className="aksi">
                      <button
                        className="btn-detail"
                        onClick={() => handleDetailClick(pasien.id_pasien)}
                      >
                        <FaFileAlt className="icon-detail" /> Detail
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9" style={{ textAlign: "center" }}>
                    Data tidak ditemukan
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <p className="footer-textsemua">© 2025 TibiSmart. All rights reserved.</p>
      </div>
    </div>
  );
}

export default DataPasienTenagaKesehatan;
